import React, { useState, Context, ReactElement, Component } from "react";

export interface storage_classes_type {
    kind: string;
    items: storage_classes_type_item[];
}

export interface storage_classes_type_item {
    metadata: {
        name: string;
        selfLink: string;
        uid: string;
        resourceVersion: string;
        creationTimestamp: string;
        annotations: object;
    },
    provisioner: string;
    parameters: {
        adminId: string;
        adminSecretName: string;
        adminSecretNamespace: string;
        imageFeatures: string;
        imageFormat: string;
        monitors: string;
        pool: string;
        userId: string
        userSecretName: string;
        userSecretNamespace: string;
    },
    reclaimPolicy: string;
    volumeBindingMode: string;
}

const StorageClassContext: Context<[storage_classes_type_item[], React.Dispatch<React.SetStateAction<storage_classes_type_item[]>>]> = React.createContext<[storage_classes_type_item[], React.Dispatch<React.SetStateAction<storage_classes_type_item[]>>]>([[] as unknown as storage_classes_type_item[], (_value: any) => { }]);

const StorageClassProvider: (props: any) => ReactElement<any, string | (new (props: any) => Component<any, any, any>)> | null = (props: any): ReactElement<any, string | (new (props: any) => Component<any, any, any>)> | null => {
    const [storage_classes, set_storage_classes]: [storage_classes_type_item[], React.Dispatch<React.SetStateAction<storage_classes_type_item[]>>] = useState([] as unknown as storage_classes_type_item[]);
    return (
        <StorageClassContext.Provider value={[storage_classes, set_storage_classes]}>
            {props.children}
        </StorageClassContext.Provider>
    )
}

export { StorageClassContext, StorageClassProvider };

